<template>
    <div class="modal fade" id="modal_new" tabindex="-1" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ title }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="clearModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label for="newModule">{{ $lang('Wybierz moduł') }}</label>
                        <select id="newModule" class="form-control" v-model="selectedModule">
                            <option v-for="module in allModules" :value="module">
                                {{ module.name + ' - ' + module.type.showable_name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group" v-if="selectedModule">
                        <label for="value">{{ selectedModule.type.showable_name }}</label>
                        <template v-if="selectedType.kind==='boolean'">
                            <div class="form-check">
                                <input type="radio" id="yes" name="value" value="1" v-model.number="value"/>
                                <label for="yes">{{ $lang('Tak') }}</label>

                                <input type="radio" id="no" name="value" value="0" v-model.number=value class="ml-2"/>
                                <label for="no">{{ $lang('Nie') }}</label>
                            </div>
                        </template>
                        <template v-else>
                            <input id="value" type="number" min="0" name="value" class="form-control"
                                   v-model.number="value"/>
                        </template>

                        <datepicker-accessible
                            :label-single="$lang('Data wygaśnięcia')"
                            custom-id="expired"
                            name="expired"
                            mode="date"
                            :use_pencil_checkbox="false"
                            :strong_label="false"
                            v-model="expired"
                        ></datepicker-accessible>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal" @click="clearModal">
                        {{ $lang('Zamknij') }}
                    </button>
                    <button @click="add" type="button" class="btn btn-primary" :disabled="!valid">
                        {{ $lang('Dodaj') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'library-module-new',
    props: {
        url: String,
        get_modules_route: String,
        trigger: Number,
        trade_module_types: Array,
        default_new_date: String,
    },
    data() {
        return {
            allModules: [],
            selectedModule: null,
            selectedType: null,
            expired: '-',
            value: (this.selectedModule != null ? this.selectedModule.default_value : ''),
            title: this.$lang("Dodaj moduł"),
        }
    },
    watch: {
        selectedModule: {
            deep: true,
            handler() {
                console.log("wybrano jakis modul!")
                if (this.selectedModule !== null) {
                    this.value = this.selectedModule.default_value;
                    this.selectedType = this.getType(this.selectedModule.type_id);
                    this.expired = this.default_new_date;
                }
            }
        },
        trigger() {
            this.getAllModules();
        }
    },
    computed: {
        valid() {
            return this.value !== '' && this.expired !== '-';
        }
    },
    methods: {
        add() {
            const self = this;
            axios.post(this.url, {
                id: this.selectedModule.id,
                value: this.value,
                expired: this.expired,
            })
                .then(function () {
                    self.$parent.getUserModules();
                    self.getAllModules();
                    self.title = self.$lang("Dodaj kolejny moduł")
                    self.clearModal();
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getAllModules() {
            const self = this;
            axios.get(this.get_modules_route)
                .then(function (response) {
                    self.allModules = response.data
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getType(id) {
            if (typeof this.trade_module_types !== 'undefined') {
                for (const type of this.trade_module_types) {
                    if (type.id === id) {
                        return type;
                    }
                }
            }
            return 0;
        },
        clearModal() {
            this.selectedModule = null;
            this.selectedType = null;
            this.expired = '-';
            this.value = '';
        }
    },
    created() {
        this.getAllModules();
    }
}
</script>
